import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import { ModalContext } from 'App';
import ReactTooltip from "react-tooltip";
import * as actions from '../action';
import * as c from '../constant';

import MenuSidebarListModal from './components/MenuSidebarListModal';

const CMS_TYPE = 'COMPONENTS';

const fields = [
  'BPLS',
  'BPLS_NEW_E2E',
  'BPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS',
  'BPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS',
  'BTAX',
  'BTAX_BIN_INPUT_FREE_TEXT',
  'BTAX_WITHOUT_PERIOD_FILTER',
  'BTAX_WITHOUT_YEAR_FILTER',
  'RPTAX',
  'RPTAX_TDN_INPUT_FREE_TEXT',
  'RPTAX_HAS_DELINQUENT_TAGGING',
  'RPTAX_HAS_SECOND_FORMAT_TAGGING',
  'RPTAX_HAS_PIN',
  // 'RPTAX_HAS_PIN_CSV', 
  'RPTAX_HAS_OR',
  'RPTAX_HAS_OR_CSV',
  'RPTAX_SECOND_FORMAT_TAGGING_LABEL',
  'FOOTER_FORMS',
  'TERMS_AND_CONDITION',
  'EMAIL_LOGIN',
  'APP_STORE_IOS',
  'APP_STORE_ANDROID',
  'TAXPAYER_PROFILE_BUSINESS',
  'TAXPAYER_RESIDENT_TAGGING',
  'TAXPAYER_VOTER_TAGGING',
  'TAXPAYER_USERNAME',
  'E_COMMERCE_COMING_SOON',
  'E_SERVICES_COMING_SOON',
  'E_BILLS_COMING_SOON',
  'E_GOVERNMENT_COMING_SOON',

  'E_WALLET',
  'TAXABLE_AMOUNT',
  'CEDULA_INDIVIDUAL_NOTE',
  'CEDULA_INDIVIDUAL_BASIC_AMOUNT',
  'CEDULA_INDIVIDUAL_BASE_INTEREST_RATE',
  'CEDULA_INDIVIDUAL_DESCRIPTION_1',
  'CEDULA_INDIVIDUAL_DESCRIPTION_2',
  'CEDULA_INDIVIDUAL_DESCRIPTION_3',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_1',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_1',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_2',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_2',

  'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_3',
  'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_3',

  'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_1',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_1',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_2',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_2',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_3',
  'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_3',

  'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID',

  'CEDULA_CORPORATION_BASIC_AMOUNT',
  'CEDULA_CORPORATION_BASE_INTEREST_RATE',

  'CEDULA_CORPORATION_DESCRIPTION_1',
  'CEDULA_CORPORATION_DESCRIPTION_2',

  'CEDULA_CORPORATION_REQUIRED_1',
  'CEDULA_CORPORATION_MINIMUM_AMOUNT_1',
  'CEDULA_CORPORATION_TAXABLE_AMOUNT_1',
  'CEDULA_CORPORATION_CEDULA_AMOUNT_1',

  'CEDULA_CORPORATION_REQUIRED_2',
  'CEDULA_CORPORATION_MINIMUM_AMOUNT_2',
  'CEDULA_CORPORATION_TAXABLE_AMOUNT_2',
  'CEDULA_CORPORATION_CEDULA_AMOUNT_2',

  'CEDULA_CORPORATION_MAX_TOTAL_AMOUNT_PAID',
  'SHOW_SELECT_QUARTER_TRANSACTION',
  'SHOW_VIEW_SOA_TRANSACTION',
  'SHOW_REGENERATE_SOA_TRANSACTION',

  // REPORTS
  'RPTAX_TRANSACTION_TYPE_TAX_CLEARANCE',
  'RPTAX_TRANSACTION_TYPE_TAX_PAYMENT',

  // Menu Header (landing page)
  'SEARCH_NOV',
  'SEARCH_OVR',
  'TOGGLE_MANILA_ZOO_LINK',

  'ANNOUNCEMENT_BANNER',
  'IMPORTANT_BANNER',
  'RPTAX_YEAR',
  'RPTAX_PERIOD',
  'RPTAX_PIN_INPUT_FREE_TEXT',
  'VIEW_CITIZEN_ID',
  'RESIDENCY_REMARKS',
  'RPTAX_SEARCH_BUTTON',
  'RPTAX_MODE_OF_PAYMENT',
  'RPTAX_AUTOMATIC_PERIOD',
  'FATHER_SUFFIX_NAME',
  'BUSINESS_ADDRESS',
  // 'BPLS_CHECK_PAYMENT_LIMIT_AMOUNT',
  'TEL_8_DIGITS',
  'RPTAX_KIND_OF_PROPERTY',

  'SMART_CITY_HEADER',
  'SMART_CITY_TRANSACTION_HISTORY',
  'SMART_CITY_SHOW_NEWS',
  'SMART_CITY_SHOW_LIST_OF_SERVICES',
  'SMART_CITY_DASHBOARD',
  'SMART_CITY_SIDE_MENU_LABELS_V2',
  'SMART_CITY_BILLING_SETTINGS_2', // display pldt smart city billing(rptax/btax) modules
  'SMART_CITY_HIDE_BUSINESS_PROFILE',
  'SMART_CITY_RPTAX_SETTINGS',
  'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX',
  'SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING',
  'SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING',

  // EBPLS
  'EBPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS',
  'EBPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS',
  'EBPLS_CANCEL_SOA'
];

const menuSidebarfields = [
  'DASHBOARD',
  'SUBSCRIBERS',
  'CITIZEN',
  'GOMANILA_SERVICES',
  // subs
  'RPT_SERVICES_SUB_MENU',
  'BPLS_SERVICES_SUB_MENU',
  'CEDULA_SERVICES_SUB_MENU',
  'CIVIL_REGISTRY_SERVICES_SUB_MENU',
  'OHP_SERVICES_SUB_MENU',
  'HEALTH_CERTIFICATE_SERVICES_SUB_MENU',
  'OCCUPATIONAL_PERMIT_SERVICES_SUB_MENU',
  'POLICE_CLEARANCE_SERVICES_SUB_MENU',
  'REAL_PROPERTY_TAX_SERVICES_SUB_MENU',
  'BTAX_SERVICES_SUB_MENU',
  'OVRS_SERVICES_SUB_MENU',
  'NOVS_SERVICES_SUB_MENU',
  'DELIVERY_TRANSACTIONS_SERVICES_SUB_MENU',
  'SOCIAL_AMELIORATION_SENIOR_CITIZENS_SERVICES_SUB_MENU',
  'REPORTS_SERVICES_SUB_MENU',
  'BPLS_REPORTS_SERVICES_SUB_MENU',
  'GCASH_REPORTS_SERVICES_SUB_MENU',
  'PAYMENT_REPORTS_SERVICES_SUB_MENU',
  'SOCIAL_AMELIORATIONS_REPORTS_SERVICES_SUB_MENU',
  'BILLINGS_REPORTS_SERVICES_SUB_MENU',
  'QR_CODE_REPORTS_SERVICES_SUB_MENU',

  'E_COMMERCE',
  'E_BILLS_PAYMENT',
  'E_SERVICES',
  'E_NEWS',
  'ARTICLES_NEWS_SUB_MENU',
  'E_WALLET_SERVICES',
  // subs
  'E_BILLS_E_WALLET_SERVICES_SUB_MENU',
  'CASH_IN_E_WALLET_SERVICES_SUB_MENU',
  'CASH_TRANSFER_E_WALLET_SERVICES_SUB_MENU',
  'RECEIVED_FUND_E_WALLET_SERVICES_SUB_MENU',
  'MOBILE_LOAD_E_WALLET_SERVICES_SUB_MENU',
  'E_WALLET_SUPPORT_E_WALLET_SERVICES_SUB_MENU',

  'E_HELP',
]

function Components({
  getList,
  createSelect,
  item,
  setFormData,
  createHidden,
  create,
  update,
  formData,
  createCheckbox,
  createInput
}) {
  const setModal = useContext(ModalContext);

  const onHandleMenuSidebarList = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <MenuSidebarListModal
        formData={formData}
        setFormData={setFormData}
        item={item}
        fields={fields}
        menuSidebarfields={menuSidebarfields}
      />,
      title: 'HIDE SIDE MENU ITEMS',
      modalSize: 'modal-lg',
    });
  };

  useEffect(() => {
    getList({ type: CMS_TYPE });
  }, []);

  useEffect(() => {
    setFormData({
      ...JSON.parse(_.get(item, 'attributes.body') || '{}'),
      id: _.get(item, 'id'),
    });
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (_.get(formData, 'id')) {
      return update(_.get(formData, 'id'), {
        type: CMS_TYPE,
        body: JSON.stringify(_.pick(formData, [...fields, ...menuSidebarfields])),
      });
    }

    return create({
      type: CMS_TYPE,
      body: JSON.stringify(_.pick(formData, [...fields, ...menuSidebarfields])),
    });
  };

  const renderToolTip = (fieldId = "", label = "enter text here") => {
    return (
      <>
        <i className="fa fa-question-circle pl-2 my-auto text-warning" data-tip="" data-for={fieldId} />
        <ReactTooltip place="top" id={fieldId} type="dark" effect="float" delayShow="300">
          <div className="">
            {label}
            {/* <img src="" alt="img" /> // todo later: add image here from cms */}
          </div>
        </ReactTooltip>
      </>
    )
  }

  return (
    <div>
      <form onSubmit={handleOnSubmit}>
        {createHidden({ key: 'id' }, { placeholder: '' })}
        <div className="row">
          <hr className="w-100 px-3" />
          <div className="col-12 form-group group-cms-color">
            <b>SMART LGU SETTINGS</b>
          </div>
          <>
            <b>SITE:</b>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_HEADER', label: 'SMART_CITY_HEADER' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_TRANSACTION_HISTORY', label: 'SMART_CITY_TRANSACTION_HISTORY' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_TRANSACTION_HISTORY", "set transaction history to default/Smart City Design |  SITE -> PROFILE/APPLICATION/TRANSACTION HISTORY")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_SHOW_NEWS', label: 'SMART_CITY_SHOW_NEWS' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_SHOW_LIST_OF_SERVICES', label: 'SMART_CITY_SHOW_LIST_OF_SERVICES' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_HIDE_BUSINESS_PROFILE', label: 'SMART_CITY_HIDE_BUSINESS_PROFILE' },
                { className: 'd-flex align-items-center align-self-center', }
              )}
              {renderToolTip("SMART_CITY_HIDE_BUSINESS_PROFILE", "Hide Business info TAB in: SITE -> PROFILE/BUSINESS")}
            </div>
            <b>CORE:</b>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_DASHBOARD', label: 'SMART_CITY_DASHBOARD' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_SIDE_MENU_LABELS_V2', label: 'SMART_CITY_SIDE_MENU_LABELS_V2' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX', label: 'SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_HIDE_CEDULA_INDIVIDUAL_OTHER_TAX", "Hide individual cedula residential tax 2 and 3")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_RPTAX_SETTINGS', label: 'SMART_CITY_RPTAX_SETTINGS' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_RPTAX_SETTINGS", "RPTAX Smart City Settings")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createCheckbox(
                { key: 'SMART_CITY_BILLING_SETTINGS_2', label: 'SMART_CITY_BILLING_SETTINGS_2' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_BILLING_SETTINGS_2", "Render new Billing Settings for Smart City (billing settings version 2) | CORE -> SIDEMENU -> BILLINGS/")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex">
              {createInput(
                { key: 'SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING', label: 'SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_SET_SPECIFIC_REGION_FOR_ADDRESS_BILLING", "Set default region for RPTAX/BTAX Billing address | NOTE: input REGION CODE ONLY | ex. -> add/edit record -> location")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex mt-2">
              {createInput(
                { key: 'SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLINGSMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING', label: 'SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("SMART_CITY_SET_SPECIFIC_PROVINCE_FOR_ADDRESS_BILLING", "Set province/district value for RPTAX/BTAX Billing address | NOTE: input PROVINCE CODE ONLY | ex. -> add/edit record -> location")}
            </div>
            <div className="col-12 group-cms-color form-input-group d-flex pt-3">
              <button className='btn btn-primary cms-bg-color-primary cms-outline-primary ' type="button" onClick={onHandleMenuSidebarList}>
                MENU SIDEBAR LIST ITEMS
              </button>
            </div>
          </>
          <hr className="w-100 px-3" />
          <div className="col-12 form-group group-cms-color">
            <b>BPLS</b>
          </div>
          <div className="col-3 form-group group-cms-color">
            {createSelect(
              { key: 'BPLS', label: 'BPLS' },
              [
                {
                  label: 'DEFAULT',
                  value: 'DEFAULT'
                },
                {
                  label: 'TEMPORARY',
                  value: 'TEMPORARY'
                },
              ],
              { required: true, type: 'text' }
            )}
          </div>
          {_.get(formData, 'BPLS') === 'TEMPORARY' && (
            <div className="group-cms-component form-input-group d-flex">
              {createCheckbox(
                { key: 'BPLS_NEW_E2E', label: 'BPL_NEW_E2E (e2e v.2)' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
            </div>
          )}
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createInput(
              { key: 'BPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS', label: 'BPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS (SITE/CORE)' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip("BPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS", "Set region/district value for SITE/CORE Application addresses | NOTE: input PROVINCE CODE ONLY ")}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex mt-2">
            {createInput(
              { key: 'BPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS', label: 'BPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS (SITE/CORE)' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip("BPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS", "Set province/district value for SITE/CORE Application addresses | NOTE: input PROVINCE CODE ONLY ")}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'BUSINESS_ADDRESS', label: 'BUSINESS_ADDRESS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          {/* <div className="col-12 group-cms-color form-input-group d-flex">
            {createInput(
              { key: 'BPLS_CHECK_PAYMENT_LIMIT_AMOUNT', label: 'BPLS_CHECK_PAYMENT_LIMIT_AMOUNT (SITE/CORE)' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip("BPLS_CHECK_PAYMENT_LIMIT_AMOUNT", "Set amount limit for check payment posting validation | Menu > BPLS > Applications > Renewal > Check payment posting (note: status should be pending/waiting for payment/ex ref no")}
          </div> */}
          <hr className="w-100 px-3" />
          <div className="col-12 form-group group-cms-color">
            <b>EBPLS</b>
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createInput(
              {
                key: 'EBPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS',
                label: 'EBPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS (SITE/CORE)',
              },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip(
              'EBPLS_SPECIFIC_REGION_FOR_ADDRESS_SETTINGS',
              'Set region/district value for SITE/CORE Application addresses | NOTE: input PROVINCE CODE ONLY '
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex mt-2">
            {createInput(
              {
                key: 'EBPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS',
                label:
                  'EBPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS (SITE/CORE)',
              },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip(
              'EBPLS_SPECIFIC_PROVINCE_FOR_ADDRESS_SETTINGS',
              'Set province/district value for SITE/CORE Application addresses | NOTE: input PROVINCE CODE ONLY '
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              {
                key: 'EBPLS_CANCEL_SOA',
                label: 'EBPLS_CANCEL_SOA (SITE)',
              },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip(
              'EBPLS_CANCEL_SOA',
              'Toggle the cancel SOA feature for eBPLS | SITE'
            )}
          </div>
          <hr />
          <div className="col-12 form-group group-cms-color">
            <b>BTAX</b>
          </div>
          <div className="col-3 form-group group-cms-color">
            {createSelect(
              { key: 'BTAX', label: 'BTAX' },
              [
                {
                  label: 'DEFAULT',
                  value: 'DEFAULT'
                },
              ],
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'BTAX_BIN_INPUT_FREE_TEXT', label: 'BTAX_BIN_INPUT_FREE_TEXT' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'BTAX_WITHOUT_PERIOD_FILTER', label: 'BTAX_WITHOUT_PERIOD_FILTER' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'BTAX_WITHOUT_YEAR_FILTER', label: 'BTAX_WITHOUT_YEAR_FILTER' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <hr />
          <div className="col-12 form-group group-cms-color">
            <b>RPTAX</b>
          </div>
          <div className="col-3 form-group group-cms-color">
            {createSelect(
              { key: 'RPTAX', label: 'RPTAX' },
              [
                {
                  label: 'DEFAULT',
                  value: 'DEFAULT'
                },
                {
                  label: 'ANGELES',
                  value: 'ANGELES'
                }
              ],
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_TDN_INPUT_FREE_TEXT', label: 'RPTAX_TDN_INPUT_FREE_TEXT' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_HAS_DELINQUENT_TAGGING', label: 'RPTAX_HAS_DELINQUENT_TAGGING' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_HAS_SECOND_FORMAT_TAGGING', label: 'RPTAX_HAS_SECOND_FORMAT_TAGGING' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_HAS_PIN', label: 'RPTAX_HAS_PIN' },
              { className: 'd-flex align-items-center align-self-center' }
            )}

            {/* {_.get(formData, 'RPTAX_HAS_PIN') === true && (
              <div className="group-cms-component form-input-group d-flex pl-4">
                {createCheckbox(
                  { key: 'RPTAX_HAS_PIN_CSV', label: 'RPTAX_HAS_PIN_CSV' },
                  { className: 'd-flex align-items-center align-self-center' }
                )}
              </div>
            )} */}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_HAS_OR', label: 'RPTAX_HAS_OR' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'RPTAX_SECOND_FORMAT_TAGGING_LABEL', label: 'RPTAX_SECOND_FORMAT_TAGGING_LABEL' },
              { type: 'text' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_YEAR', label: 'RPTAX_YEAR' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_PERIOD', label: 'RPTAX_PERIOD' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_PIN_INPUT_FREE_TEXT', label: 'RPTAX_PIN_INPUT_FREE_TEXT' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RPTAX_SEARCH_BUTTON', label: 'RPTAX_SEARCH_BUTTON' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'RPTAX_MODE_OF_PAYMENT', label: 'RPTAX_MODE_OF_PAYMENT' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'RPTAX_AUTOMATIC_PERIOD', label: 'RPTAX_AUTOMATIC_PERIOD' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'RPTAX_KIND_OF_PROPERTY', label: 'RPTAX_KIND_OF_PROPERTY' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-GOV REPORTS</b>
            <br />
            <b>RPTAX:</b>
            <div className="col-12 form-group group-cms-color d-flex">
              {createCheckbox(
                { key: 'RPTAX_TRANSACTION_TYPE_TAX_CLEARANCE', label: 'RPTAX_TRANSACTION_TYPE_TAX_CLEARANCE' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("RPTAX_TRANSACTION_TYPE_TAX_CLEARANCE", "render rptax transaction type options | REPORTS -> RPTAX TAB -> -> Transaction Types")}
            </div>
            <div className="col-12 form-group group-cms-color d-flex">
              {createCheckbox(
                { key: 'RPTAX_TRANSACTION_TYPE_TAX_PAYMENT', label: 'RPTAX_TRANSACTION_TYPE_TAX_PAYMENT' },
                { className: 'd-flex align-items-center align-self-center' }
              )}
              {renderToolTip("RPTAX_TRANSACTION_TYPE_TAX_PAYMENT", "render rptax transaction type options | REPORTS -> RPTAX TAB -> Transaction Types")}
            </div>            
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>LOGIN OPTIONS</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'EMAIL_LOGIN', label: 'EMAIL_LOGIN' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>APP STORE</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'APP_STORE_IOS', label: 'APP_STORE_IOS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'APP_STORE_ANDROID', label: 'APP_STORE_ANDROID' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>DISPLAY ANNOUNCEMENT_BANNER</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'ANNOUNCEMENT_BANNER', label: 'ANNOUNCEMENT_BANNER' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>DISPLAY IMPORTANT_BANNER</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'IMPORTANT_BANNER', label: 'IMPORTANT_BANNER' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>TAX PAYER</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TAXPAYER_PROFILE_BUSINESS', label: 'TAXPAYER_PROFILE_BUSINESS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TAXPAYER_RESIDENT_TAGGING', label: 'TAXPAYER_RESIDENT_TAGGING' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TAXPAYER_VOTER_TAGGING', label: 'TAXPAYER_VOTER_TAGGING' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TAXPAYER_USERNAME', label: 'TAXPAYER_USERNAME' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'VIEW_CITIZEN_ID', label: 'VIEW_CITIZEN_ID' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'RESIDENCY_REMARKS', label: 'RESIDENCY_REMARKS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'FATHER_SUFFIX_NAME', label: 'FATHER_SUFFIX_NAME' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 group-cms-color form-input-group d-flex">
            {createCheckbox(
              { key: 'TEL_8_DIGITS', label: 'TEL_8_DIGITS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-COMMERCE</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'E_COMMERCE_COMING_SOON', label: 'E_COMMERCE_COMING_SOON' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-BILLS</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'E_BILLS_COMING_SOON', label: 'E_BILLS_COMING_SOON' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-GOVERNMENT</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'E_GOVERNMENT_COMING_SOON', label: 'E_GOVERNMENT_COMING_SOON' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'SHOW_SELECT_QUARTER_TRANSACTION', label: 'SHOW_SELECT_QUARTER_TRANSACTION' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'SHOW_VIEW_SOA_TRANSACTION', label: 'SHOW_VIEW_SOA_TRANSACTION' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'SHOW_REGENERATE_SOA_TRANSACTION', label: 'SHOW_REGENERATE_SOA_TRANSACTION' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        {/* E-WALLET */}
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-WALLET</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'E_WALLET', label: 'E_WALLET' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>E-SERVICES</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'E_SERVICES_COMING_SOON', label: 'E_SERVICES_COMING_SOON' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>

        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>HEADER (PUBLIC)</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'SEARCH_NOV', label: 'SEARCH_NOV' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'SEARCH_OVR', label: 'SEARCH_OVR' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TOGGLE_MANILA_ZOO_LINK', label: 'TOGGLE_MANILA_ZOO_LINK' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
            {renderToolTip("TOGGLE_MANILA_ZOO_LINK", "Show/Hide Manila Zoo Link on Menu Header (Landing Page)")}
          </div>
        </div>

        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>FOOTER</b>
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'FOOTER_FORMS', label: 'FOOTER_FORMS' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-12 form-group group-cms-color d-flex">
            {createCheckbox(
              { key: 'TERMS_AND_CONDITION', label: 'TERMS_AND_CONDITION' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
        </div>
        <hr />
        <div className="row mt-1">
          <div className="col-12 form-group group-cms-color">
            <b>CEDULA </b>
            <br />
            <small>GENERAL</small>
          </div>
          <div className="col-12 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_NOTE', label: 'NOTE' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_BASIC_AMOUNT', label: 'BASIC AMOUNT' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_BASE_INTEREST_RATE', label: 'BASE INTEREST RATE' },
              { type: 'text' }
            )}
          </div>
          {/* EMPLOYED START */}
          <div className="col-12 form-group group-cms-color">
            <small>INDIVIDUAL EMPLOYED</small>
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_DESCRIPTION_1', label: 'DESCRIPTION 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_1', label: 'EMPLOYED TAXABLE AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_1', label: 'EMPLOYED CEDULA AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_1', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_1', label: 'MINIMUM AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_DESCRIPTION_2', label: 'DESCRIPTION 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_2', label: 'EMPLOYED TAXABLE AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_2', label: 'EMPLOYED CEDULA AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_2', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_2', label: 'MINIMUM AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_DESCRIPTION_3', label: 'DESCRIPTION 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_TAXABLE_AMOUNT_3', label: 'EMPLOYED TAXABLE AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_CEDULA_AMOUNT_3', label: 'EMPLOYED CEDULA AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_REQUIRED_3', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_MINIMUM_AMOUNT_3', label: 'MINIMUM AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_EMPLOYED_MAX_TOTAL_AMOUNT_PAID', label: 'MAX TOTAL AMOUNT PAID' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'TAXABLE_AMOUNT', label: 'TAXABLE AMOUNT DISABLED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          {/* EMPLOYED END */}
          <hr />
          {/* UNEMPLOYED START */}
          <div className="col-12 form-group group-cms-color">
            <small>INDIVIDUAL UNEMPLOYED</small>
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_1', label: 'UNEMPLOYED TAXABLE AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_1', label: 'UNEMPLOYED CEDULA AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_1', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_1', label: 'MINIMUM AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_2', label: 'UNEMPLOYED TAXABLE AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_2', label: 'UNEMPLOYED CEDULA AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_2', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_2', label: 'MINIMUM AMOUNT ' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_TAXABLE_AMOUNT_3', label: 'UNEMPLOYED TAXABLE AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_CEDULA_AMOUNT_3', label: 'UNEMPLOYED CEDULA AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_REQUIRED_3', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_MINIMUM_AMOUNT_3', label: 'MINIMUM AMOUNT 3' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_INDIVIDUAL_UNEMPLOYED_MAX_TOTAL_AMOUNT_PAID', label: 'MAX TOTAL AMOUNT PAID' },
              { type: 'text' }
            )}
          </div>
          {/* UNEMPLOYED END */}
          {/* CORPORATION START */}
          <div className="col-12 form-group group-cms-color">
            <small>CORPORATION</small>
          </div>
          <div className="col-12 form-group group-cms-color">
            <small>GENERAL</small>
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_BASIC_AMOUNT', label: 'BASIC AMOUNT' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_BASE_INTEREST_RATE', label: 'BASE INTEREST RATE' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_DESCRIPTION_1', label: 'DESCRIPTION 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_TAXABLE_AMOUNT_1', label: 'TAXABLE AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_CEDULA_AMOUNT_1', label: 'CEDULA AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_CORPORATION_REQUIRED_1', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_MINIMUM_AMOUNT_1', label: 'MINIMUM AMOUNT 1' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_DESCRIPTION_2', label: 'DESCRIPTION 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_TAXABLE_AMOUNT_2', label: 'TAXABLE AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_CEDULA_AMOUNT_2', label: 'CEDULA AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            {createCheckbox(
              { key: 'CEDULA_CORPORATION_REQUIRED_2', label: 'REQUIRED' },
              { className: 'd-flex align-items-center align-self-center' }
            )}
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_MINIMUM_AMOUNT_2', label: 'MINIMUM AMOUNT 2' },
              { type: 'text' }
            )}
          </div>
          <div className="col-6 group-cms-color form-input-group">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group  d-flex">
            &nbsp;
          </div>
          <div className="col-3 group-cms-color form-input-group">
            {createInput(
              { key: 'CEDULA_CORPORATION_MAX_TOTAL_AMOUNT_PAID', label: 'MAX TOTAL AMOUNT PAID' },
              { type: 'text' }
            )}
          </div>
          {/* CORPORATION END */}
        </div>
        <div className="d-flex justify-content-center">
          <button
            // disabled={creating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {/* {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`} */}
              Submit
            </span>
          </button>
        </div>
      </form>
    </div>
  );
}

Components.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  createHidden: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  create: PropTypes.instanceOf(Function).isRequired,
  update: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  createCheckbox: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_SETTINGS}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(Components);
